import SearchableProperty from './SearchableProperty';
export default SearchableProperty;